(() => {
  "use strict";

  const cleanProductDetails = (root = document) => {
    root.querySelectorAll("product-info .product__description.rte").forEach((description) => {
      if (description.dataset.immershopDetailsCleaned === "true") return;

      description.querySelectorAll("tr").forEach((row) => {
        const cells = Array.from(row.querySelectorAll("th, td"));
        const label = (cells[0]?.textContent || "").trim().toLocaleLowerCase("it");
        if (["opzioni spedizione", "ships from", "warehouse", "dispatch origin", "paese magazzino"].includes(label)) {
          row.remove();
        }
      });

      const replacements = [
        [/Reclinabile\s*\(\s*liftable\s*\)/gi, "Reclinabile"],
        [/Regolabile\s*\(\s*adjustable handrail\s*\)/gi, "Regolabile"],
        [/\(\s*handrail\s*\)/gi, ""],
        [/liftable\s*\/\s*reclinabile/gi, "reclinabile"],
      ];
      const walker = document.createTreeWalker(description, NodeFilter.SHOW_TEXT);
      const textNodes = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode);
      textNodes.forEach((node) => {
        let value = node.nodeValue || "";
        replacements.forEach(([pattern, replacement]) => { value = value.replace(pattern, replacement); });
        node.nodeValue = value.replace(/\s{2,}/g, " ");
      });
      description.dataset.immershopDetailsCleaned = "true";
    });
  };

  const startCartAttention = () => {
    const cartLink = document.querySelector("#cart-icon-bubble");
    if (!cartLink || cartLink.dataset.immershopAttentionBound === "true") return;

    let attentionTimer;
    const ensureCartPresentation = () => {
      const legacyIcon = cartLink.querySelector(":scope > .svg-wrapper");
      if (legacyIcon && !cartLink.querySelector(":scope > .header__icon-visual")) {
        const visual = document.createElement("span");
        visual.className = "header__icon-visual";
        visual.setAttribute("aria-hidden", "true");
        legacyIcon.before(visual);
        visual.append(legacyIcon);
      }

      if (!cartLink.querySelector(":scope > .header__icon-label")) {
        const label = document.createElement("span");
        label.className = "header__icon-label";
        label.textContent = cartLink.dataset.immershopCartLabel || "Carrello";
        const accessibleLabel = cartLink.querySelector(":scope > .visually-hidden");
        cartLink.insertBefore(label, accessibleLabel || cartLink.firstChild);
      }
    };

    const updateAttention = () => {
      ensureCartPresentation();
      window.clearTimeout(attentionTimer);
      cartLink.classList.remove("immershop-cart-attention");
      if (!cartLink.querySelector(".cart-count-bubble")) return;

      window.requestAnimationFrame(() => {
        cartLink.classList.add("immershop-cart-attention");
        attentionTimer = window.setTimeout(() => cartLink.classList.remove("immershop-cart-attention"), 900);
      });
    };

    new MutationObserver(updateAttention).observe(cartLink, { childList: true, subtree: true });
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => window.setTimeout(updateAttention, 120));
    }
    cartLink.dataset.immershopAttentionBound = "true";
    updateAttention();
  };

  document.addEventListener("DOMContentLoaded", () => {
    cleanProductDetails();
    startCartAttention();
  });
  document.addEventListener("shopify:section:load", (event) => {
    cleanProductDetails(event.target);
    startCartAttention();
  });
})();
